import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import UserContextProvider from "./context/UserContextProvide";
import Home from "./pages/Home/Home";
import Aboutus from "./pages/Aboutus/Aboutus";
import Request from "./pages/Request/Request";
import Faq from "./pages/Faq/Faq";
import Termandcondition from "./pages/Termandcondition/Termandcondition";
import Privacypolicy from "./pages/Privacypolicy/Privacypolicy";
import AdminLogin from "./pages/Admin/LoginPage/AdminLogin";
import Members from "./pages/Admin/Members/Members";
import UpdatePassword from "./pages/Admin/UpdatePassword/UpdatePassword";
import UserAccess from "./pages/Admin/UserAccess/UserAccess";
import Investment from "./pages/Admin/Investment/Investment";
import Portfolios from "./pages/Admin/Portfolios/Portfolios";
import Login from "./pages/Login/Login";
import OTP from "./pages/OTP/OTP";
import InvestmentDetail from "./pages/Admin/Investment/Investment Detail/InvestmentDetail";
import AddInvestment from "./pages/Admin/Investment/AddInvestment/AddInvestment";
import PortfolioDetail from "./pages/Admin/Portfolios/Porfolio Detail/PortfolioDetail";
import AddPortfolioDetail from "./pages/Admin/Portfolios/Add Portfolio Details/AddPortfolioDetail";
import AddInvToPortfolio from "./pages/Admin/Portfolios/AddInvToPortfolio/AddInvToPortfolio";
import OpportunitiesDetail from "./pages/Dashboard/Opportunities/OpportunitiesDetail/OpportunitiesDetails";
import NewMembers from "./pages/Admin/Portfolios/Porfolio Detail/Members/NewMembers";
import MemberDetail from "./pages/Admin/Portfolios/Porfolio Detail/Members/MemberDetail/MemberDetail";
import InvestmentCommitment from "./pages/Admin/Investment/Investment Detail/Commitment/InvestmentCommitment";
import NotFound from "./pages/PageNotFound/NotFound";
import KYC_Detail from "./pages/Admin/Members/KYC_Detail/KYC_Detail";
import UpdateInvestment from "./pages/Admin/Investment/UpdateInvestment/UpdateInvestment";
import Referral from "./pages/Admin/Portfolios/Referral/Referral";
import AdminRef from "./pages/Admin/Portfolios/Referral/RefDetails/AdminRef";
import ReferralReq from "./pages/Request/ReferralReq/ReferralReq";
import PartnerLogin from "./pages/Partner/LoginPage/PartnerLogin";
import PartnerReferral from "./pages/Partner/PartnerRef/PartnerReferral";
import UpdatePartnerPassword from "./pages/Partner/UpadatePassword/UpdatePartnerPassword";
import MemberTeamDetail from "./pages/Dashboard/Sponsorship/Sponsorship_Components/TeamDetail/MemberTeamDetail";
import MemberPlayerDetail from "./pages/Dashboard/Sponsorship/Sponsorship_Components/Player/PlayerDetail/MemberPlayerDetail";
import ProtectedRouteUser from "./ProtectedRoute/ProtectedRouteUser";
import ProtectedRouteAdmin from "./ProtectedRoute/ProtectedRouteAdmin";
import ProtectedRoutePartner from "./ProtectedRoute/ProtectedRoutePartner";
import SignUp from "./pages/SignUp/SignUp";
import MemberRoutes from "./pages/Dashboard/Routes/MemberRoutes";
import { AuthProvider } from "./ProtectedRoute/AuthContext";
import Registered from "./pages/Registered/Registered";
import { PWAProvider } from "./context/PWAContext";
import FacilityAdmin from "./pages/FacilityAdmin/FacilityAdmin";
import ProtectedRouteFacility from "./ProtectedRoute/ProtectedRouteFacility";
import FacilityDashboard from "./pages/FacilityAdmin/Dashboard/FacilityDashboard";
import FacilityDetails from "./pages/FacilityAdmin/Dashboard/FacilityDetails";
import FacilityDetailsMain from "./pages/FacilityAdmin/Dashboard/FacilityDetailsMain";
import FacilityMainDashboard from "./pages/FacilityAdmin/Dashboard/FacilityMainDashboard";
import FacilityChangePassword from "./pages/FacilityAdmin/Dashboard/FacilityChangePassword";
import FacilityList from "./pages/Admin/FacilityList/FacilityList";
import FacilityAllBookings from "./pages/FacilityAdmin/Dashboard/FacilityAllBookings";
import AllBookingAdmin from "./pages/Admin/AllBookings/AllBookingAdmin";
import MembersList from "./pages/Admin/NewMembers/MembersList";
import MemberListDetails from "./pages/Admin/NewMembers/MemberListDetails/MemberListDetails";
import AdminAllBookingsDetails from "./pages/Admin/AllBookings/Details/AdminAllBookingsDetails";
import InvoiceZip from "./pages/Admin/GetInvoice/InvoiceZip";
import Support from "./pages/Dashboard/Support/Support";
import FacilitySupport from "./pages/FacilityAdmin/FacilitySupport";
import AboutMePhoneScreen from "./pages/Dashboard/MyProfile/MobProfile/AboutMePhoneScreen";
import OnboardingScreen from "./pages/Dashboard/OnboardingScreen/OnboardingScreen";
// import Payment from "./pages/Admin/Payment/Payment";

function App() {
  const token = window.localStorage.getItem("access_token");
  const flag = window.localStorage.getItem("flag");
  const userLoggedIn = token && flag === "member";
  const adminLoggedIn = token && flag === "admin";
  const partnerLoggedIn = token && flag == "partner";
  const facilityLoggedIn = token && flag === "facility_admin";
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPopup(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const handleAddToHomeScreen = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt(); // Show the install prompt
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the A2HS prompt");
        } else {
          console.log("User dismissed the A2HS prompt");
        }
        setDeferredPrompt(null); // Clear the saved prompt
        setShowPopup(false); // Hide the popup
      });
    }
  };

  const handleClosePopup = () => {
    setShowPopup(false); // Hide the popup
  };

  return (
    <div>
      {/* {showPopup && (
        <div className="popup">
          <div className="popup-content">
            <p>Add our app to your home screen for a better experience!</p>
            <div className="popup-buttons">
              <button onClick={handleAddToHomeScreen} className="btn-primary">
                Add to Home Screen
              </button>
              <button onClick={handleClosePopup} className="btn-secondary">
                Cancel
              </button>
            </div>
          </div>
        </div>
      )} */}
      <UserContextProvider>
        <AuthProvider>
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/aboutus" element={<Aboutus />} />
            <Route exact path="/requestinvite" element={<Request />} />
            <Route exact path="/applymembership" element={<ReferralReq />} />
            <Route exact path="/signUp" element={<SignUp />} />
            <Route exact path="/registered" element={<Registered />} />
            <Route exact path="/facilityadmin" element={<FacilityAdmin />} />
            {!facilityLoggedIn && (
              <Route exact path="/facilityadmin" element={<FacilityAdmin />} />
            )}

            <Route element={<ProtectedRouteFacility />}>
              <Route
                path="/facility/schedule"
                element={<FacilityDashboard />}
              />
              <Route
                path="/facility/allbookings"
                element={<FacilityAllBookings />}
              />
              <Route
                path="/facility/details"
                element={<FacilityDetailsMain />}
              />
              <Route
                path="/facility/dashboard"
                element={<FacilityMainDashboard />}
              />
              <Route
                path="/facility/updatePassword"
                element={<FacilityChangePassword />}
              />
              <Route path="/facility/support" element={<FacilitySupport />} />
            </Route>

            {/* <Route exact path="/payment" element={<Payment />} /> 

            {/* <Route exact path="/Philanthropy" element={<Philanthropy />} /> */}
            {/* {!partnerLoggedIn && (
              <Route exact path="/partnerlogin" element={<PartnerLogin />} />
            )}
            <Route element={<ProtectedRoutePartner />}>
              <Route
                exact
                path="/partnerlogin"
                element={<Navigate to="/partner/referral" />}
              />
              <Route
                exact
                path="/partner/referral"
                element={<PartnerReferral />}
              />
              <Route
                exact
                path="/partner/updatePassword"
                element={<UpdatePartnerPassword />}
              />
            </Route> */}
            {/* Admin Login and Routes */}
            {!adminLoggedIn && (
              <Route path="/adminlogin" element={<AdminLogin />} />
            )}
            {/* Protected Route Admin */}
            <Route element={<ProtectedRouteAdmin />}>
              <Route
                path="/adminlogin"
                element={<Navigate to="/admin/facility" />}
              />
              <Route path="/admin/facility" element={<FacilityList />} />
              <Route path="/admin/allbookings" element={<AllBookingAdmin />} />
              <Route path="/admin/members" element={<MembersList />} />
              <Route path="/admin/invoice" element={<InvoiceZip />} />

              <Route path="/admin/members/detail" element={<KYC_Detail />} />
              <Route path="/admin/update" element={<UpdatePassword />} />
              <Route path="/admin/userAccess" element={<UserAccess />} />
              <Route
                path="/admin/allbookings/details"
                element={<AdminAllBookingsDetails />}
              />

              {/* <Route path="/admin/investments" element={<Investment />} /> */}
              <Route path="/admin/facility/add" element={<AddInvestment />} />
              <Route
                path="/admin/facility/details/:id"
                element={<InvestmentDetail />}
              />
              <Route
                path="/admin/members/details/:id"
                element={<MemberListDetails />}
              />
              <Route
                path="/admin/facility/edit"
                element={<UpdateInvestment />}
              />
              {/* <Route path="/admin/portfolio" element={<Portfolios />} /> */}
              {/* <Route
                path="/admin/philanthropy/*"
                element={<PhilanthrophyAdmin />}
              /> */}
              {/* <Route
              path="/admin/philanthropy/add_philanthropy"
              element={<AddPhylan />}
            /> */}
              {/* <Route path="/portfolio/newMember" element={<NewMembers />} /> */}
              {/* <Route
                path="/admin/portfolio/newMember/detail"
                element={<MemberDetail />}
              />
              <Route
                path="/admin/portfolio/details"
                element={<PortfolioDetail />}
              />
              <Route
                path="/admin/portfolio/add"
                element={<AddPortfolioDetail />}
              />
              <Route
                path="/admin/portfolio/invPortfolio"
                element={<AddInvToPortfolio />}
              />
              <Route
                path="/admin/investments/commitments"
                element={<InvestmentCommitment />}
              />

             */}
              {/* <Route path="/admin/referral" element={<Referral />} />

              <Route path="/admin/referral/admin" element={<AdminRef />} /> */}
            </Route>

            {/* User Login */}
            {!userLoggedIn && (
              <>
                <Route path="/login" element={<Login />} />
                <Route exact path="/verifyOTP" element={<OTP />} />
                <Route path="/" element={<Login />} />
              </>
            )}
            {/* Protected Route User */}
            <Route element={<ProtectedRouteUser />}>
              <Route
                path="/login"
                element={<Navigate to="/dashboard/booking" />}
              />
              <Route path="/verifyOTP" element={<Navigate to="/" />} />
              <Route
                path="/dashboard/*"
                element={
                  <MemberRoutes
                    showPopup={showPopup}
                    handleAddToHomeScreen={handleAddToHomeScreen}
                  />
                }
              />
              <Route
                path="/dashboard/onboarding"
                element={<OnboardingScreen />}
              />
              {/* <Route
                path="/dashboard/sponsee/team/details"
                element={<MemberTeamDetail />}
              /> */}
              {/* <Route
                path="/dashboard/sponsee/player/details"
                element={<MemberPlayerDetail />}
              /> */}
            </Route>

            <Route path="/faq" element={<Faq />} />
            <Route path="/termsandcondition" element={<Termandcondition />} />
            <Route path="/privacypolicy" element={<Privacypolicy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </UserContextProvider>
    </div>
  );
}

export default App;
